import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
// import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";
// import OutlinedInput from "@mui/material/OutlinedInput";
import ViewDialogThreePart from "../Global/ViewDialogThreePart";
import ViewDialogFourPart from "./ViewDialogFourPart";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import IconButton from "@mui/material/IconButton";
import LoadingOverlay from "react-loading-overlay-ts";
import { styled } from "@mui/material/styles";
import AddCMToLoanDialog from "./AddCMToLoanDialog";
import { useSelector, useDispatch } from "react-redux";
import { exportLBbyLoan } from "../../Actions";

const getLB = (state) => state.loansReducer;
const RootTableRow = styled("tr")({
  "& .MuiTableCell-root": {
    padding: "4px 16px", // adjust the padding of table cells
  },
  "& .MuiTableRow-root": {
    height: "30px", // set the height of each row
  },
});

const LoanProfile = ({ loanData }) => {
  const processedData = [
    [
      {
        label: "Loan Name",
        value: loanData?.name,
      },
      {
        label: "Total Loan Amount",
        value: `₦ ${new Intl.NumberFormat().format(loanData?.amount)}`,
      },
      
    ],
    [
      {
        label: "Partner",
        value: loanData?.partner?.name,
      },
      
      {
        label: "Expiry Date",
        value: moment(loanData?.expiryDate).format("DD/MM/YYYY"),
      },
    ],
    [
      {
        label: "Sector",
        value: loanData?.sector,
      },
      
      {
        label: "No of Beneficiaries",
        value: loanData?.sec,
      },
    ],
  ];

  return (
    <Grid container direction="column" style={{ paddingTop: "2rem" }}>
      <Grid
        item
        xs
        style={{
          display: "flex",
          justifyContent: "center",
          maxHeight: "150px",
          // backgroundColor: "rgba(255,0,0,0.05)",
        }}
      >
        <div
          style={{
            width: "7rem",
            height: "7rem",
            borderRadius: "50%",
            backgroundColor: "rgba(0,0,0,0.1)",
          }}
        ></div>
      </Grid>

      {/* Loan Metadata */}
      <Grid item xs container direction="column" spacing={2} style={{ maxHeight: "8rem"}}>
        {processedData.map((row) => {
          debugger
          return (
            <Grid
              item
              xs
              container
              direction="row"
              key={row[0].value}
              spacing={3}
              style={{
                margin: 0,
                maxHeight: "150px",
                // backgroundColor: "rgba(255,0,0,0.05)",
              }}
            >
              {row.map((field) => {
                return (
                  <Grid
                    item
                    xs
                    style={{
                      display: "flex",
                      width: "20rem",
                      // flexGrow: 2,
                      paddingTop: "0",
                      // backgroundColor: "rgba(255,0,0,0.05)",
                    }}
                    key={`${field.value}+${field.label}`}
                  >
                    <TextField
                      value={field.value}
                      label={field.label}
                      variant="standard"
                      color="primary"
                      fullWidth
                      size="small"
                      style={{
                        display: "flex",
                        // backgroundColor: "rgba(255,0,0,0.05)",
                        // flexGrow: 2,
                        // padding: "1rem"
                      }}
                      disabled
                      InputProps={{
                        disableUnderline: true,
                        style: { border: "none" },
                        sx: {
                          "& .MuiInputBase-input": {
                            color: "black !important",
                            WebkitTextFillColor: "black !important",
                          },
                        },
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

const AwardedCMList = ({ loanData, dialogIsOpen}) => {
  const [awardedCM, setAwardedCM] = useState([]);
  const [addCMToLoanDialogIsOpen, setaddCMToLoanDialogIsOpen] = useState(false);
  const { awardedCMFetched, loanBeneficiaryCreated, totalLBCount, isFetching } = useSelector(getLB);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const openAddCMToLoanDialog = () => {
    setaddCMToLoanDialogIsOpen(true);
  };

  const handleCloseAddCMToLoanDialog = () => {
    setaddCMToLoanDialogIsOpen(false);
  };
  

  // const changePage = (page) => {
  //   setIsLoading(true);
  //   setPageNumber(page);
  // };
  const columns = [
    {
      name: "sn",
      label: "S/N",
    },
    {
      name: "cmName",
      label: "Corps Member",
      options: {
        customBodyRender: (value) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
      },
    },
    {
      name: "stateCode",
      label: "State Code",
      options: {
        customBodyRender: (value) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
      },
    },
    {
      name: "dateCreated",
      label: "Date Awarded",
      options: {
        customBodyRender: (value) => {
          return moment(value).format("DD/MM/YYYY");
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    print: false,
    viewColumns: false,
    jumpToPage: true,
    rowsPerPageOptions: [],
    sort: false,
    filter: false,
    search: false,
    // download: true,
    // count: totalLBCount,
    // serverSide:true,
    // page: pageNumber - 1,
    responsive:'standard',
    // toolbar: {
    //   search: "Search",
    //   downloadCsv: "Export sheet",
    //   print: "Print page",
    //   viewColumns: "View columns",
    //   filterTable: "Filter table",
    // },
    onDownload: (buildHead, buildBody, columns, data) => {
      debugger
      // const loanID = loanData?.id
      console.log(loanData, "print loandata")
      dispatch(exportLBbyLoan(loanData.id));
      return false;
    },
    // onTableChange: (action, tableState) => {
    //   if (action === "changePage") {
    //     setIsLoading(true);
    //     changePage(tableState.page + 1);
    //     return () => {
    //       setIsLoading(false);
    //     };
    //   }
    // },
    setRowProps: (row, dataIndex) => {
      return { component: RootTableRow };
    },
    customToolbar: () => {
      return (
        <>
          {/* <Tooltip title="Award Loan"> */}
          <Button
            variant="contained"
            onClick={() => {
              openAddCMToLoanDialog();
            }}
          >
            Award Loan
          </Button>
          {/* </Tooltip> */}
        </>
      );
    },
    textLabels: {
      body: {
        noMatch: "This loan has not been awarded to any corps member",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
    },
  };

  useEffect(() => {
  }, [awardedCM]);

  // useEffect(() => {
  //   if (typeof loanData === "object" && loanData !== null)
  //     if (Object.keys(loanData).length > 0) {
  //       let loanBeneficiariesList = [];
  //       let counter = 1;
  //       loanData.loanBeneficiary.map((lb) => {
  //         loanBeneficiariesList.push({
  //           sn: counter++,
  //           cmName: lb.cmName,
  //           stateCode: lb.stateCode,
  //           dateCreated: lb.dateCreated,
  //         });
  //         counter += 1;
  //       });
  //       return setAwardedCM(loanBeneficiariesList);
  //     }
  // }, [loanData]);

  
  useEffect(() => {
    if (Object.keys(awardedCMFetched).length > 0) {
      // setIsLoading(false)
      let loanBeneficiariesList = [];
      let counter = 0;
      awardedCMFetched.map((lb) => {
        loanBeneficiariesList.push({
          sn: counter + 1,
          cmName: lb.cmName,
          stateCode: lb.cmStateCode,
          dateCreated: lb.dateCreated,
        });
        counter += 1;
      });
      return setAwardedCM(loanBeneficiariesList);
    }
  }, [awardedCMFetched]);

  useEffect(() => {
    if (dialogIsOpen === false) {
      setAwardedCM([]);
    }
  }, [dialogIsOpen]);

  return (
    <div
      style={{
        // display: "flex",
        // flexGrow: 1,
        width: "100%",
        padding: "1rem",
      }}
    >
      {/* MUI Datatable */}
      <LoadingOverlay
                        active={isFetching}
                        styles={{
                          overlay: (base) => ({
                            ...base,
                            background: "rgba(0, 0, 0, 0.15)",
                          }),
                        }}
                        spinner
                        text="Fetching Data for You..."
                      >
        <MUIDataTable data={awardedCM} columns={columns} options={options} />
      </LoadingOverlay>

      <AddCMToLoanDialog
        addCMToLoanDialogIsOpen={addCMToLoanDialogIsOpen}
        handleCloseAddCMToLoanDialog={handleCloseAddCMToLoanDialog}
        loanData={loanData}
      />
    </div>
  );
};

const AwardLoanDialog = ({ isOpen, onCloseHandler, loanDetails }) => {
  const handleClose = () => {
    debugger
    onCloseHandler();
  };

  return (
    <ViewDialogThreePart
      isOpen={isOpen}
      onCloseHandler={handleClose}
      columnOneChildren={<LoanProfile loanData={loanDetails} />}
      columnTwoChildren={<AwardedCMList loanData={loanDetails} dialogIsOpen={isOpen} />}
      dialogTitle={"Award Loan"}
      // actions={}
    />
  );
};

export default AwardLoanDialog;
